import React from "react";

const TableCreateIcon = ({ className = "" }) => {
  const classes = ["anticon", "table-page-header-create-icon", className]
    .filter(Boolean)
    .join(" ");

  return (
    <span aria-hidden="true" className={classes}>
      <svg
        viewBox="0 0 1024 1024"
        focusable="false"
        width="1em"
        height="1em"
        fill="currentColor"
      >
        <path d="M474 152h76v720h-76z" />
        <path d="M152 474h720v76H152z" />
      </svg>
    </span>
  );
};

export default TableCreateIcon;
